import { Debug } from "@ctra/utils";

Debug.create("pushNotifications", "Push Notifications", { transports: true });

export { default as Push } from "./push";
